import request from '@/assets/js/request';
import store from '@/store';

/**
 * @description 上传文件
 * @export
 * @param {*} formData
 * @returns
 */
export function uploadFile(formData, onUploadProgress) {
    return request({
        formData: false,
        url: 'file/upload.json',
        method: 'POST',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        onUploadProgress: onUploadProgress || function () {},
    });
}

/**
 * @description base64方式上传图片
 * @export
 * @param {*} formData
 * @returns
 */
export function uploadImg(formData, onUploadProgress) {
    return request({
        formData: false,
        url: '/file/imageProc.json',
        method: 'POST',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        onUploadProgress: onUploadProgress || function () {},
    });
}

/**
 * @description base64方式上传图片
 * @export
 * @param {*} formData
 * @returns
 */
export function uploadImgByBase64(formData, onUploadProgress) {
    return request({
        formData: false,
        url: '/file/upload_base64.json',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        onUploadProgress: onUploadProgress || function () {},
    });
}

/**
 * @description 歌曲源文件上传
 * @export
 * @param {*} formData
 * @returns
 */
export function uploadMusic(formData, onUploadProgress) {
    return request({
        formData: false,
        url: '/file/uploadMusic.json',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        data: formData,
        onUploadProgress: onUploadProgress || function () {},
    });
}

/**
 * @description 上传歌曲文件并检测/修复 WAV 文件头
 * 返回 id + status，status: 0待处理 1修复中 2修复成功 3修复失败 4阻断 5无阻断问题
 * @param {Object} data
 */
export function uploadMusicCheckFix(data) {
    return request({
        formData: false,
        url: '/file/upload_music_check_fix.json',
        method: 'post',
        timeout: 60 * 60 * 1000,
        data: data.formData,
        params: data?.params,
        onUploadProgress: data.onUploadProgress || function () {},
        cancelToken: data.cancelToken,
    });
}

/**
 * @description 轮询音频检测/修复状态
 * @param {Object} params { id }
 */
export function fetchMusicCheckFixStatus(params, cancelToken) {
    return request({
        url: '/file/upload_music_check_fix/status.json',
        method: 'get',
        params,
        cancelToken,
    });
}

/**
 * @description 试听
 * @param {String} path 文件路径
 * @returns {String} {试听全路径}
 */
export function fetchAudioXcodeUrl(path) {
    return request({
        url: '/file/get_audio_xcode_url.json',
        method: 'post',
        data: {
            fileUrl: path,
        },
    }).then((res) => {
        if (!res.data.state) {
            return res;
        }

        const {result} = res.data;

        const userId = store.state.userInfo.id;

        res.data.result = result.indexOf('?') === -1 ? `${result}?userId=${userId}` : `${result}&userId=${userId}`;
        return res;
    });
}

/**
 * @description 获取音频Id3信息
 * @param {*} formData
 */
export function fetchId3Info(formData) {
    return request({
        url: '/newAlbumTrack/queryAudioID3Info',
        method: 'post',
        formData: false,
        data: formData,
    });
}

/**
 * @description 歌词文本后端生成文件上传
 * @param {*} formData
 */
export function uploadLyricByText(formData) {
    return request({
        url: '/file/uploadLyricByText',
        method: 'post',
        formData: false,
        data: formData,
    }).then(response => {
        const {state, result} = response.data;
        if (!state) return Promise.resolve(response);

        return request({
            url: '/file/parseFileType',
            method: 'POST',
            formData: false,
            data: {
                filePath: result.url
            }
        }).then(res => {
            const {state: resState, result: resResult} = res.data;
            if (!resState) return Promise.resolve(res);

            const {label} = resResult;
            if (label === 'lrc' || label === 'krc' || label === 'txt') {
                return Promise.resolve(response);
            }

            return Promise.resolve({
                data: {
                    state: false,
                    msg: `只支持TXT或lrc文件，不要通过修改文件后缀上传文件`
                }
            });
        });
    });
}

/**
 * @description 获取AI歌词
 * @param {*} formData
 */
export function getAILyric(formData) {
    return request({
        url: '/file/create/rollingLyrics',
        method: 'post',
        formData: false,
        data: formData,
    });
}

/**
 * @description 根据文件相对路径下载文件
 * @export
 * @param {*} uri
 * @param {*} fileName
 */
export async function downLoadByUri(filePath, fileName) {
    const res = await request({
        url: '/file/download_by_file_url',
        method: 'post',
        // timeout: 60 * 60 * 1000,
        params: {fileUrl: filePath, fileName: fileName},
        responseType: 'blob',
    });
    downLoadByBlob(res.data, fileName);
}

export function downLoadByBlob(blob, fileName) {
    const blobUri = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = blobUri;
    a.download = fileName || '';

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(blobUri);
}
